import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import PT from "prop-types";
import { Button } from "../../atoms/button";
import { IS_OPEN_LOGIN_FORM } from "../../helper/actions";
import "./login-button.m.css";

const LoginButtonBase = ({ text = "Login to view details", manageLoginForm, isLoginOpen }) => {
  function handleLogin(e) {
    e.preventDefault();
    !isLoginOpen && manageLoginForm(true);
  }
  return (
    <div styleName="wrapper">
      <h1>{text}...</h1>
      <div styleName="button" onClick={e => handleLogin(e)}>
        <Button>Login</Button>
      </div>
    </div>
  );
};

LoginButtonBase.propTypes = {
  text: PT.string,
  manageLoginForm: PT.func,
  isLoginOpen: PT.bool
};

const mapDispatchToProps = dispatch => ({
  manageLoginForm: function(payload) {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: payload
    });
  }
});

const mapStateToProps = state => ({
  isLoginOpen: get(state, ["isLoginOpen"], false)
});

export const LoginButton = connect(mapStateToProps, mapDispatchToProps)(LoginButtonBase);
